import { SkeletonLoading } from "../Skeleton";

export function ChartCardLoading() {
  return (
    <>
      <div style={{ marginBottom: "8px" }}>
        <SkeletonLoading height="22px" width="100px" />
      </div>

      <SkeletonLoading height="22px" />

      <div style={{ marginTop: "16px" }}>
        <SkeletonLoading height="100px" />
      </div>

      <div
        style={{
          marginTop: "16px",
        }}
      >
        <SkeletonLoading height="30px" />
      </div>
    </>
  );
}
